import { render, staticRenderFns } from "./CategoryProductModal.vue?vue&type=template&id=1a96c6c0"
import script from "./CategoryProductModal.vue?vue&type=script&lang=ts"
export * from "./CategoryProductModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a96c6c0')) {
      api.createRecord('1a96c6c0', component.options)
    } else {
      api.reload('1a96c6c0', component.options)
    }
    module.hot.accept("./CategoryProductModal.vue?vue&type=template&id=1a96c6c0", function () {
      api.rerender('1a96c6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/category-product/components/CategoryProductModal.vue"
export default component.exports